import { render, staticRenderFns } from "./tradehistory.vue?vue&type=template&id=343565db&scoped=true&"
import script from "./tradehistory.vue?vue&type=script&lang=js&"
export * from "./tradehistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343565db",
  null
  
)

export default component.exports